jQuery(document).ready(function($) {

   if( typeof mobile_tabs_variable != 'undefined' ){
        if($(window).width() < 768){

                // change background color
                if(mobile_tabs_variable.mtChange){
                        $(".mobile-tabs .mobile-tab").css({"background": mobile_tabs_variable.mtBGColor, "color": mobile_tabs_variable.mtFontColor, "border-color": mobile_tabs_variable.mtBorderColor});
                }

                // calculate the header height and pushed the content down that amount
                if(mobile_tabs_variable.mtMoveToTop){

                        var getMobileTabsHeight = $(".mobile-tabs").height();
                        var getMobileHeaderHeight

                        if($("#tablet-mobile-header").length > 0){
                                getMobileHeaderHeight = $("#tablet-mobile-header").height();
                        }else{
                                getMobileHeaderHeight = $(".menu-top").height();
                        }

                        if(mobile_tabs_variable.mobileTabsDDVal === "addpadding"){
                                getMobileTabsHeight = parseInt(getMobileTabsHeight) + parseInt(mobile_tabs_variable.mobileTabsDDNum);
                        }else if(mobile_tabs_variable.mobileTabsDDVal === "removepadding"){
                                getMobileTabsHeight = parseInt(getMobileTabsHeight) - parseInt(mobile_tabs_variable.mobileTabsDDNum);                           
                        } 

                        if($(".fixed-top-spacer").length > 0 && $(".fixed-top-spacer").height() > getMobileHeaderHeight){
                                 getMobileHeaderHeight = parseInt(getMobileHeaderHeight) - $(".fixed-top-spacer").height();
                        }
                        
                        if( mobile_tabs_variable.mobile_top_override == true ){
                          var top = mobile_tabs_variable.mobile_top_override_position;
                          mobile_tabs_top_override(top);
                        }

                   //     $(".mobile-tabs").css({"bottom": "auto", "top": getMobileHeaderHeight});
                   //     $("#whitewrap").css("margin-top", getMobileTabsHeight);
                   //     $("#vehicleDetails .maincta-row .button").css("top", getMobileHeaderHeight + getMobileTabsHeight);
                   //     $(".mobile-tab-content.open").css("top", getMobileHeaderHeight + getMobileTabsHeight);
                }
        }

        // mooved tab content down 
        $('.mobile-tabs .mobile-tab').on('click', function () {
                if(mobile_tabs_variable.mtMoveToTop){
                        var getMobileTabsHeight = $(".mobile-tabs").height();
                        $(".mobile-tab-content.open").css("top", getMobileHeaderHeight + getMobileTabsHeight);
                }
        });

        // fix closing issue when moving content down
        $('.mobile-tabs .mobile-tab .mobile-tab-close').on('click', function () {
                if(mobile_tabs_variable.mtMoveToTop){
                        $(this).parent().parent().css("top", "110%");
                }
        });
   }
    function mobile_tabs_top_override(top_position){
      if( window.outerWidth < 768 ){
        top_position = parseInt(top_position,10);
        mobile_tabs_top = top_position;

        if($(".fixed-top-spacer:visible") && $(".fixed-top-spacer").height() > 0 ){
          $(".mobile-tabs").css({"top":mobile_tabs_top+ "px"});
        }
        else{
      //  openhoursbar = 40 + top_position ;
      //  contentcontainer = (65 + top_position) ;
      //  vdp_top = (85 + top_position) ;
      //  vdp_cta_top = (95 + top_position) ;
      //  $(" #openhoursbar").css({"margin-top":openhoursbar+ "px"});
          $(".mobile-tabs").css({"top":mobile_tabs_top+ "px"});
        //  $("#contentwrap, .contentcontainer, #di-page-composer.contentcontainer").css({"padding-top":contentcontainer+ "px"});
        //  $("#vehicleDetails.project-hotwheels").css({"margin-top":vdp_top+ "px"});
        //  $("#vehicleDetails.project-hotwheels .maincta-row .button").css({"top":vdp_cta_top+ "px"});
        
        }
      }
    }
});
